import React from "react";
import { LoginCallback } from "@okta/okta-react";
import { Spin } from "antd";

/**
 * Wrapper around Okta's LoginCallback component.
 *
 * Shows a loading spinner during token processing to prevent
 * the login form from flashing briefly during SSO/IDP redirects.
 */
const LoginCallbackWrapper = () => {
  /**
   * Custom loading component shown during token processing.
   * This prevents the login form from appearing briefly during the
   * callback processing phase when returning from an external IDP.
   *
   * Note: Using a div with flexbox instead of Row with justify/align props
   * for more reliable centering, and placing text below the spinner.
   */
  const LoadingComponent = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#fff"
      }}
    >
      <Spin size="large" />
      <div style={{ marginTop: 16, color: "#666", fontSize: 14 }}>Completing sign in...</div>
    </div>
  );

  return <LoginCallback loadingElement={<LoadingComponent />} />;
};

export default LoginCallbackWrapper;
